import {useState} from 'react';

const SLUG=/^[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?$/;

export function TenantFinder({baseDomain}:{baseDomain:string}){
 const [slug,setSlug]=useState('');
 const [error,setError]=useState('');
 return (
  <main className="login-wrap">
   <section className="login-panel">
    <div className="login-brand">eSaaS<span>.app</span></div>
    <h1>Open your workspace</h1>
    <p>Enter your company address to continue</p>
    <form onSubmit={e=>{
     e.preventDefault();
     const value=slug.trim().toLowerCase();
     if(!SLUG.test(value)){setError('Enter a valid workspace address');return}
     setError('');
     window.location.assign(`https://${value}.${baseDomain}/`);
    }}>
     <label>Workspace
      <input
       name="tenant"
       autoComplete="organization"
       value={slug}
       onChange={e=>setSlug(e.target.value)}
       placeholder="your-company"
       required
      />
     </label>
     <p className="muted">{slug.trim()?`${slug.trim().toLowerCase()}.${baseDomain}`:baseDomain}</p>
     <p role="alert">{error}</p>
     <button className="primary" type="submit">Continue</button>
    </form>
   </section>
  </main>
 );
}
